import moment from 'moment-timezone';
import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Capacity Management Mirage Scenario
 * - `MIRAGE_SCENARIO='capacity-management' yarn start:mirage`
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  const {
    subscription,
    locations: [location],
  } = visitorsClassicScenario(server);

  subscription.update({
    features: [
      'pre_registration_required',
      'billing',
      'sign_in_visitors',
      'custom_notifications',
      'group_sign_in',
      'nda_enabled',
      'visitor_photos',
      'visitor_badge_printing',
      'sms_notification',
      'slideshows',
      'custom_badge',
      'presign_nda',
      'multiple_visitor_types',
      'sign_in_from_invite',
      'slack',
      'analytics',
      'assistants',
      'blacklist',
      'locations_grouping',
      'global_analytics',
      'rooms-calendar-permissions',
    ],
  });

  const capacityLimit = 100;
  location.update({ capacityLimit });

  // generate limits for 2 weeks before and after today.
  const capacityLimitCount = 28;
  server
    .createList('locations-capacity', capacityLimitCount, { locationId: location.id })
    .forEach((locationsCapacity, idx) => {
      const dayOffset = idx - capacityLimitCount / 2;
      const capacityDate = moment().startOf('date').add(dayOffset, 'days').toDate();
      locationsCapacity.update({ capacityDate, capacityLimit });
    });

  server.createList('location-role', 15, { locationIds: [location.id] }).forEach((locationRole) => {
    const userId = server.create('user').id;
    locationRole.update({ userId: userId });
  });

  const globalFlow = server.create('flow', {
    enabled: true,
    name: 'Employee registration',
    type: 'Flows::EmployeeScreening',
  });

  server.create('sign-in-field-page', { flow: globalFlow });
}
